const { fbq } = window;

export default {
  namespaced: true,
  actions: {
    test({ dispatch }) {
      try {
        fbq('trackCustom', 'Test', { emittedAt: Date.now() });
      } catch (e) {
        dispatch('errorOverlay/setMessage', e, { root: true });
      }
    },
    signUp({ dispatch }) {
      try {
        fbq('trackCustom', 'SignUp');
      } catch (e) {
        dispatch('errorOverlay/setMessage', e, { root: true });
      }
    },
  },
};
